<template >
  <div class="mainbody">
    <!-- ========== 列表视图 ========== -->
    <template v-if="viewMode === 'list'">
      <div style="padding: 16px 32px 16px 0px">
        <span class="title">返校报备列表</span>
        <el-button type="primary" size="small" style="float: right;" @click="enterBlacklist">黑名单</el-button>
      </div>
      <div class="aLine"></div>
      <!-- 搜索筛选区域 -->
      <div style="padding: 16px 32px; background: #fafafa; margin-bottom: 16px;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="搜索">
            <el-input
              v-model="searchForm.search"
              placeholder="请输入学号或校友姓名"
              clearable
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.screen_status" placeholder="请选择状态" multiple collapse-tags clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约日期">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="aLine"></div>
      <div class="tableInfo">
        <el-table :data="data_list" key="list-table">
          <el-table-column prop="id" label="ID" min-width="1"></el-table-column>
          <el-table-column prop="student_no" label="学号" min-width="1"></el-table-column>
          <el-table-column prop="alumni_name" label="校友名称" min-width="1"></el-table-column>
          <el-table-column prop="visit_date" label="访校日期" min-width="1"></el-table-column>
          <el-table-column prop="plate_no" label="车牌号" min-width="1"></el-table-column>
          <el-table-column prop="statusStr" label="状态" min-width="1"></el-table-column>
          <el-table-column prop="visitor_count" label="同行人数" min-width="1"></el-table-column>
          <el-table-column prop="create_time" label="申请时间" min-width="1"></el-table-column>
          <el-table-column prop="operating" label="操作" min-width="1" align="left">
            <template slot-scope="scope">
              <el-button class="operateText" size="mini" type="text" @click="enterDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :key="elementui_page_key"
          class="elPagination"
          background
          layout="prev, pager, next"
          :page-size="pageMaxSize"
          :page-count="pageCount"
          :current-page="currentPage"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </template>

    <!-- ========== 详情视图 ========== -->
    <template v-if="viewMode === 'detail'">
      <!-- 面包屑导航 -->
      <div style="padding: 16px 32px 16px 0px">
        <span class="title" style="cursor: pointer; padding-right: 0;" @click="backToList">返校报备列表</span>
        <span class="title" style="padding-left: 0; padding-right: 0;">/</span>
        <span class="title" style="padding-left: 0;">详情</span>
      </div>
      <div class="aLine"></div>

      <!-- 预约信息（浅灰背景） -->
      <div style="padding: 16px 32px; background: #fafafa; margin-bottom: 16px;">
        <div class="info_row">
          <div class="info_div">
            <span class="info_label">学号：</span>
            <span class="info_value">{{ detail.apply.student_no }}</span>
          </div>
          <div class="info_div">
            <span class="info_label">预约日期：</span>
            <span class="info_value">{{ detail.apply.visit_date }}</span>
          </div>
        </div>
        <div class="info_row">
          <div class="info_div">
            <span class="info_label">车牌号：</span>
            <span class="info_value">{{ detail.apply.plate_no || '无' }}</span>
          </div>
          <div class="info_div">
            <span class="info_label">状态：</span>
            <span class="info_value">{{ statusMap[detail.apply.status] || detail.apply.status }}</span>
          </div>
        </div>
        <div class="info_row">
          <div class="info_div">
            <span class="info_label">申请时间：</span>
            <span class="info_value">{{ detail.apply.create_time }}</span>
          </div>
        </div>
      </div>

      <!-- 访客列表 -->
      <h3 class="title">访客列表（共{{ detail.visitors ? detail.visitors.length : 0 }}人）</h3>
      <div class="aLine"></div>
      <div class="tableInfo">
        <el-table :data="detail.visitors" style="width: 100%" v-loading="detailLoading">
          <el-table-column prop="inviter_no" label="邀请编号" min-width="160"></el-table-column>
          <el-table-column prop="type" label="人员类型" min-width="90">
            <template slot-scope="scope">
              {{ visitorTypeMap[scope.row.type] || scope.row.type }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
          <el-table-column prop="id_type" label="证件类型" min-width="120">
            <template slot-scope="scope">
              {{ idTypeMap[scope.row.id_type] || scope.row.id_type }}
            </template>
          </el-table-column>
          <el-table-column prop="id_card" label="证件号码" min-width="160"></el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="120"></el-table-column>
          <el-table-column prop="gender" label="性别" min-width="60">
            <template slot-scope="scope">
              {{ genderMap[scope.row.gender] || scope.row.gender }}
            </template>
          </el-table-column>
          <el-table-column prop="api_status" label="推送状态" min-width="90">
            <template slot-scope="scope">
              {{ apiStatusMap[scope.row.api_status] || scope.row.api_status }}
            </template>
          </el-table-column>
          <el-table-column prop="api_error_msg" label="推送结果" min-width="140">
            <template slot-scope="scope">
              {{ scope.row.api_error_msg || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="pass_direction" label="通行记录" min-width="80">
            <template slot-scope="scope">
              {{ passDirectionMap[scope.row.pass_direction] || scope.row.pass_direction }}
            </template>
          </el-table-column>
          <el-table-column prop="pass_time" label="通行时间" min-width="140">
            <template slot-scope="scope">
              {{ scope.row.pass_time || '-' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>

    <!-- ========== 黑名单视图 ========== -->
    <template v-if="viewMode === 'blacklist'">
      <div style="padding: 16px 32px 16px 0px">
        <span class="title" style="cursor: pointer; padding-right: 0;" @click="backToList">返校报备列表</span>
        <span class="title" style="padding-left: 0; padding-right: 0;">/</span>
        <span class="title" style="padding-left: 0;">黑名单列表</span>
        <el-button type="primary" size="small" style="float: right;" @click="addBlacklist">添加</el-button>
      </div>
      <div class="aLine"></div>
      <div class="tableInfo">
        <el-table :data="blacklist_data" key="blacklist-table">
          <el-table-column prop="id" label="ID" min-width="1"></el-table-column>
          <el-table-column prop="student_no" label="学号" min-width="1"></el-table-column>
          <el-table-column prop="alumni_name" label="姓名" min-width="1"></el-table-column>
          <el-table-column prop="reason" label="黑名单原因" min-width="1"></el-table-column>
          <el-table-column prop="create_admin_name" label="操作管理员名称" min-width="1"></el-table-column>
          <el-table-column prop="create_time" label="操作时间" min-width="1"></el-table-column>
          <el-table-column prop="operating" label="操作" min-width="1" align="left">
            <template slot-scope="scope">
              <el-button class="operateText" size="mini" type="text" @click="cancelBlacklist(scope.row)">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :key="blacklist_page_key"
          class="elPagination"
          background
          layout="prev, pager, next"
          :page-size="blacklistPageMaxSize"
          :page-count="blacklistPageCount"
          :current-page="blacklistCurrentPage"
          @current-change="blacklistCurrentChange"
        ></el-pagination>
      </div>
    </template>

    <!-- 添加黑名单弹窗 -->
    <el-dialog title="添加黑名单" :visible.sync="addBlacklistDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="addBlacklistForm" label-width="100px">
        <el-form-item label="学号">
          <el-input v-model="addBlacklistForm.student_no" placeholder="请输入学号" clearable></el-input>
        </el-form-item>
        <el-form-item label="拉黑原因">
          <el-input v-model="addBlacklistForm.reason" type="textarea" :rows="3" placeholder="请输入拉黑原因" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addBlacklistDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddBlacklist">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import { LIST_PAGE_MAX_SIZE } from '@/config/config'

export default {
  data() {
    return {
      viewMode: 'list', // list | detail | blacklist
      // === 列表相关 ===
      data_list: [],
      elementui_page_key: 0,
      pageCount: 0,
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      searchForm: {
        search: '',
        screen_status: []
      },
      dateRange: [],
      statusOptions: [
        { label: '待入校', value: '1' },
        { label: '已入校', value: '2' },
        { label: '已过期', value: '3' },
        { label: '已取消', value: '4' }
      ],
      statusMap: {
        1: '待入校',
        2: '已入校',
        3: '已过期',
        4: '已取消'
      },
      // === 详情相关 ===
      detailLoading: false,
      detail: {
        apply: {},
        visitors: []
      },
      visitorTypeMap: {
        1: '校友本人',
        2: '同行人'
      },
      idTypeMap: {
        1: '身份证',
        2: '港澳居民来往内地通行证',
        3: '台湾居民来往大陆通行证',
        4: '护照'
      },
      genderMap: {
        M: '男',
        F: '女'
      },
      apiStatusMap: {
        0: '未推送',
        1: '已推送',
        2: '推送失败',
        3: '已取消'
      },
      passDirectionMap: {
        0: '无',
        1: '进',
        2: '出'
      },
      // === 黑名单相关 ===
      blacklist_data: [],
      blacklist_page_key: 0,
      blacklistPageCount: 0,
      blacklistCurrentPage: 1,
      blacklistPageMaxSize: LIST_PAGE_MAX_SIZE,
      addBlacklistDialogVisible: false,
      addBlacklistForm: {
        student_no: '',
        reason: ''
      }
    }
  },
  activated() {
    if (this.viewMode === 'list') {
      this.getList()
    } else if (this.viewMode === 'blacklist') {
      this.getBlacklist()
    }
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    // ========== 列表 ==========
    getList: function () {
      let params = {
        token: localStorage.getItem('token'),
        page: this.currentPage,
        limit: this.pageMaxSize,
        search: this.searchForm.search || undefined,
        screen_status: this.searchForm.screen_status.length > 0 ? this.searchForm.screen_status.join(';') : undefined,
        visit_date_start: this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : undefined,
        visit_date_end: this.dateRange && this.dateRange.length > 0 ? this.dateRange[1] : undefined
      }
      this.$api
        .campusVisitList(params)
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
            return
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            info.statusStr = this.statusMap[info.status] || info.status
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    resetSearch() {
      this.searchForm = {
        search: '',
        screen_status: []
      }
      this.dateRange = []
      this.currentPage = 1
      this.getList()
    },
    // ========== 详情 ==========
    enterDetail(row) {
      this.viewMode = 'detail'
      this.getDetail(row.id)
    },
    backToList() {
      this.viewMode = 'list'
      this.detail = { apply: {}, visitors: [] }
      this.blacklist_data = []
      this.$nextTick(() => {
        this.getList()
      })
    },
    getDetail(applyId) {
      this.detailLoading = true
      this.$api
        .campusVisitDetail({
          token: localStorage.getItem('token'),
          apply_id: applyId
        })
        .then(({ data }) => {
          this.detail = data.Data
          this.detailLoading = false
        })
        .catch(({ error }) => {
          this.detailLoading = false
        })
    },
    // ========== 黑名单 ==========
    enterBlacklist() {
      this.viewMode = 'blacklist'
      this.blacklistCurrentPage = 1
      this.$nextTick(() => {
        this.getBlacklist()
      })
    },
    getBlacklist() {
      let params = {
        token: localStorage.getItem('token'),
        page: this.blacklistCurrentPage,
        limit: this.blacklistPageMaxSize
      }
      this.$api
        .campusVisitBlacklist(params)
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.blacklistCurrentPage)
          if (current_page) {
            this.blacklistCurrentPage = current_page
            this.getBlacklist()
            return
          }
          this.blacklistPageCount = data.Data.pageCount
          this.blacklist_data = data.Data.model
        })
        .catch(({ error }) => {})
    },
    blacklistCurrentChange(val) {
      this.blacklist_page_key++
      this.blacklistCurrentPage = val
      this.getBlacklist()
    },
    addBlacklist() {
      this.addBlacklistForm = { student_no: '', reason: '' }
      this.addBlacklistDialogVisible = true
    },
    submitAddBlacklist() {
      if (!this.addBlacklistForm.student_no) {
        this.$message.error('请输入学号')
        return
      }
      if (!this.addBlacklistForm.reason) {
        this.$message.error('请输入拉黑原因')
        return
      }
      this.$api
        .campusVisitAddBlacklist({
          token: localStorage.getItem('token'),
          student_no: this.addBlacklistForm.student_no,
          reason: this.addBlacklistForm.reason
        })
        .then(({ data }) => {
          this.$message.success('添加成功')
          this.addBlacklistDialogVisible = false
          this.blacklistCurrentPage = 1
          this.getBlacklist()
        })
        .catch(({ error }) => {})
    },
    cancelBlacklist(row) {
      this.$confirm('确定要撤销该黑名单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .campusVisitDelBlacklist({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.$message.success('撤销成功')
              this.getBlacklist()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.operateText {
  font-size: 14px;
}
/* 详情-预约信息 */
.info_row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 4px;
}
.info_row .info_div {
  display: flex;
  align-items: center;
  width: 350px;
  margin-bottom: 8px;
}
.info_row .info_label {
  font-size: 14px;
  color: #8c8c8c;
  white-space: nowrap;
}
.info_row .info_value {
  font-size: 14px;
  color: #262626;
}
</style>



// WEBPACK FOOTER //
// src/components/welfare/campusVisitList.vue